import { Box, Typography } from "@mui/material";
import { colorTextMuted, colorTextPrimary } from "src/design/tokens";

interface Props {
  title: string;
  subtitle?: string;
  // Spacing below the subtitle. Chart cards need the extra room the plot area
  // would otherwise eat into; text-based cards sit tighter.
  subtitleSpacing?: number;
}

// Shared title/subtitle block for every analytics card below the page header,
// so a card never drifts from the others' heading style.
export const AnalyticsCardHeader = ({
  title,
  subtitle,
  subtitleSpacing = 1.5,
}: Props) => (
  <Box>
    <Typography
      component="h3"
      sx={{ fontSize: "1rem", fontWeight: 600, color: colorTextPrimary, mb: 0.5 }}
    >
      {title}
    </Typography>
    {subtitle && (
      <Typography sx={{ fontSize: "0.75rem", color: colorTextMuted, mb: subtitleSpacing }}>
        {subtitle}
      </Typography>
    )}
  </Box>
);
